import React from 'react';
import { Tab } from '../types';
import { CreativeTemplatesEntities } from '../constants';
import { ImagesTab } from '../components/AssetsTabs/components/ImagesTab';
import { VideosTab } from '../components/AssetsTabs/components/VideosTab';
import { TextAssetsTab } from '../components/AssetsTabs/components/TextAssetsTab';

export const TabsDef: Tab[] = [
  {
    label: 'Image',
    key: CreativeTemplatesEntities.IMAGES,
    component: <ImagesTab />
  },
  {
    label: 'Video',
    key: CreativeTemplatesEntities.VIDEOS,
    component: <VideosTab />
  },
  {
    label: 'Headline',
    key: CreativeTemplatesEntities.Headlines,
    component: <TextAssetsTab />
  },
  {
    label: 'Post Text',
    key: CreativeTemplatesEntities.PostTexts,
    component: <TextAssetsTab />
  },
  {
    label: 'Description',
    key: CreativeTemplatesEntities.Descriptions,
    component: <TextAssetsTab />
  },
  {
    label: 'CTA',
    key: CreativeTemplatesEntities.CTAs,
    component: <TextAssetsTab />
  }
];

export const DEFAULT_TAB = TabsDef[0];
